import type { ContractorTranslation } from './en';

export const hi: ContractorTranslation = {
  common: {
    cancel: 'रद्द करें',
    save: 'सेव करें',
    retry: 'फिर से कोशिश करें',
    download: 'डाउनलोड करें',
    continue: 'आगे बढ़ें',
    yes: 'हाँ',
    no: 'नहीं',
    genericError: 'कुछ गड़बड़ हो गई। कृपया फिर से कोशिश करें।',
    networkError: 'DubForge से कनेक्ट नहीं हो सका। अपना इंटरनेट कनेक्शन जाँचें।',
  },
  app: {
    tagline: 'डबिंग असाइनमेंट, फ़ाइलें और समीक्षाएँ, सब एक जगह।',
    startupFailed: 'DubForge शुरू नहीं हो सका',
    notFoundTitle: 'पेज नहीं मिला',
    notFoundBody: 'यह पेज मौजूद नहीं है या आपके पास इसकी अनुमति नहीं है।',
    goHome: 'होम पर जाएँ',
    crashTitle: 'कुछ गड़बड़ हो गई',
    crashBody: 'पेज को रीलोड करके देखें।',
    reload: 'रीलोड करें',
  },
  language: {
    label: 'भाषा',
    change: 'भाषा बदलें',
  },
  welcome: {
    title: 'DubForge में आपका स्वागत है',
    body: 'अपनी भाषा चुनें। DubForge और आपकी Discord सूचनाएँ इसी भाषा में होंगी।',
    changeLater: 'आप इसे कभी भी ऊपर दाईं ओर के भाषा मेनू से बदल सकते हैं।',
  },
  nav: {
    myAssignments: 'मेरे असाइनमेंट',
    openMenu: 'मेनू खोलें',
    account: 'खाता',
    notificationEmail: 'सूचनाओं के लिए ईमेल',
    signOut: 'साइन आउट करें',
    roleAdmin: 'एडमिन',
    roleContractor: 'डबिंग कलाकार',
    lightMode: 'लाइट मोड',
    darkMode: 'डार्क मोड',
  },
  login: {
    signIn: 'Discord से साइन इन करें',
    onlyInvited: 'केवल वही Discord खाते साइन इन कर सकते हैं जिन्हें चैनल के मालिक ने जोड़ा है।',
    signingIn: 'साइन इन हो रहा है…',
    backToSignIn: 'साइन इन पर वापस जाएँ',
    failed: 'साइन इन नहीं हो सका। कृपया फिर से कोशिश करें।',
  },
  authErrors: {
    not_invited: 'यह Discord खाता DubForge में नहीं जोड़ा गया है। चैनल के मालिक से आपको जोड़ने के लिए कहें।',
    access_off: 'DubForge तक आपकी पहुँच बंद कर दी गई है।',
    discord_only: 'आप केवल Discord से साइन इन कर सकते हैं।',
  },
  errors: {
    not_signed_in: 'आपका सेशन खत्म हो गया है। कृपया फिर से साइन इन करें।',
    access_off: 'DubForge तक आपकी पहुँच बंद कर दी गई है।',
    admins_only: 'आपको ऐसा करने की अनुमति नहीं है।',
    not_found: 'यह आइटम मौजूद नहीं है या अब उपलब्ध नहीं है।',
    invalid_request: 'इस अनुरोध में कुछ सही नहीं है। जाँचकर फिर से कोशिश करें।',
    conflict: 'यह पहले से मौजूद है।',
    already_approved: 'यह असाइनमेंट पहले ही स्वीकृत हो चुका है, इसलिए अब और अपलोड करने की ज़रूरत नहीं है।',
    not_audio: 'केवल WAV या MP3 फ़ाइलें अपलोड की जा सकती हैं। केवल अपना वॉइस ट्रैक अपलोड करें।',
    upload_incomplete: 'अपलोड पूरा नहीं हुआ। कृपया फिर से कोशिश करें।',
    discord_unreachable: 'Discord से कनेक्ट नहीं हो सका। कृपया बाद में कोशिश करें।',
    server_error: 'हमारी तरफ़ से कुछ गड़बड़ हो गई। कृपया फिर से कोशिश करें।',
  },
  notifications: {
    title: 'सूचनाएँ',
    openWithCount: 'सूचनाएँ ({{count}} अपठित)',
    markAllRead: 'सभी को पढ़ा हुआ मार्क करें',
    empty: 'अभी तक कुछ नहीं।',
  },
  emailSettings: {
    body: 'जब आपको कोई नया असाइनमेंट मिलता है और जब आपके काम की समीक्षा हो जाती है, तब हम आपको ईमेल भेजते हैं।',
    label: 'ईमेल पता',
    fromDiscord: 'यह आपके Discord खाते से लिया गया है। अगर आप कोई दूसरा पता चाहते हैं, तो इसे बदल दें।',
    saved: 'ईमेल पता सेव हो गया',
    invalid: 'मान्य ईमेल पता दर्ज करें।',
    missing: 'अभी कोई ईमेल पता नहीं है। सूचनाएँ पाने के लिए एक जोड़ें।',
  },
  status: {
    Assigned: 'असाइन किया गया',
    InProgress: 'काम जारी है',
    Submitted: 'समीक्षा का इंतज़ार',
    ChangesRequested: 'बदलाव का अनुरोध',
    Approved: 'स्वीकृत',
  },
  assetKind: {
    package: 'डबिंग पैकेज (वीडियो + आवाज़ + SFX)',
    video: 'संदर्भ वीडियो (720p)',
    sfx: 'SFX / म्यूज़िक ट्रैक',
    voice: 'मूल वॉइस ट्रैक',
    script: 'स्क्रिप्ट',
    other: 'अन्य',
  },
  translation: {
    machine: 'मशीन से अनुवादित',
    showOriginal: 'मूल देखें',
    showTranslation: 'अनुवाद देखें',
  },
  uploader: {
    progress: '{{size}} में से {{percent}}%',
    queued: 'अपलोड की कतार में: {{count}}',
    keepOpen: 'पूरा होने तक यह टैब खुला रखें।',
    cancelled: 'अपलोड रद्द किया गया',
    done: '{{name}} अपलोड हो गई',
    failed: 'अपलोड नहीं हो सका: {{error}}',
  },
  my: {
    greeting: 'नमस्ते, {{name}}',
    subtitle: 'आपके डबिंग असाइनमेंट।',
    emptyTitle: 'अभी कोई असाइनमेंट नहीं है',
    emptyBody: 'जब आपको कोई वीडियो दिया जाएगा, तो आपको Discord पर मैसेज मिलेगा और वह यहाँ दिखेगा।',
    todo: 'करना बाकी',
    waiting: 'समीक्षा का इंतज़ार',
    done: 'पूरे हुए',
    updated: '{{when}} अपडेट किया गया',
  },
  assignment: {
    back: 'मेरे असाइनमेंट',
    dubIn: 'डबिंग: {{language}}',
    paid: 'भुगतान हो गया',
    next: {
      Assigned: 'सोर्स फ़ाइलें डाउनलोड करें, अपनी आवाज़ रिकॉर्ड करें, फिर अपना वॉइस ट्रैक यहाँ अपलोड करें।',
      InProgress: 'जब आपका वॉइस ट्रैक तैयार हो जाए, तो उसे नीचे अपलोड करें।',
      Submitted: 'आपकी डबिंग समीक्षा के लिए भेज दी गई है। समीक्षा होने पर आपको Discord पर मैसेज मिलेगा।',
      ChangesRequested: 'बदलाव का अनुरोध किया गया है। नीचे दिया गया फ़ीडबैक पढ़ें, फिर नया वर्शन अपलोड करें।',
      Approved: 'स्वीकृत हो गया। धन्यवाद!',
    },
    notes: 'नोट्स',
    sourceFiles: 'सोर्स फ़ाइलें',
    noFiles: 'अभी तक कोई फ़ाइल अपलोड नहीं की गई है।',
    fileInfo: '{{kind}} · {{size}}',
    packageHint: 'वीडियो और दो ऑडियो ट्रैक वाली एक .mp4 फ़ाइल: ट्रैक 1 में मूल डायलॉग हैं, ट्रैक 2 में SFX।',
    uploadTitle: 'अपना वॉइस ट्रैक अपलोड करें',
    voiceOnlyTitle: 'सिर्फ़ आपकी आवाज़',
    voiceOnlyBody:
      'सिर्फ़ अपनी रिकॉर्ड की गई आवाज़ अपलोड करें: कोई म्यूज़िक, साउंड इफ़ेक्ट या मूल ऑडियो का कोई हिस्सा नहीं। ध्यान रखें कि इसकी लंबाई मूल ऑडियो जितनी ही हो।',
    voiceOnlyConfirm: 'इस फ़ाइल में केवल डायलॉग की आवाज़ है।',
    dropLabel: 'वॉइस ट्रैक यहाँ अपलोड करें',
    dropHint: 'केवल WAV या MP3।',
    noteForReviewer: 'समीक्षक के लिए नोट (वैकल्पिक)',
    lengthTitle: 'लंबाई मेल नहीं खाती',
    lengthBody:
      'आपकी फ़ाइल {{dub}} लंबी है, लेकिन SFX ट्रैक {{sfx}} का है। अगर आपका ट्रैक किसी दूसरी जगह से शुरू होता है या बीच में कटा है, तो वह वीडियो के साथ मेल नहीं खाएगा। फिर भी अपलोड करें?',
    uploadAnyway: 'फिर भी अपलोड करें',
    chooseAnother: 'दूसरी फ़ाइल चुनें',
    versions: 'अपलोड किए गए वर्शन',
    nothingUploaded: 'अभी तक कुछ अपलोड नहीं किया गया है।',
    version: 'वर्शन {{version}}',
    reviewApproved: 'स्वीकृत',
    reviewChanges: 'बदलाव का अनुरोध',
    reviewPending: 'समीक्षा का इंतज़ार',
    yourNote: 'आपका नोट:',
    feedback: 'फ़ीडबैक',
    listen: 'सुनें',
    uploadedOn: '{{date}} · {{size}}',
    length: 'लंबाई: {{duration}}',
  },
};
